import { Component } from '@angular/core';

@Component({
    selector: 'app-defective-products',
    templateUrl: './defective-products.component.html',
    styleUrls: ['./defective-products.component.scss'],
})
export class DefectiveProductsComponent {}
